import * as API from '@/api';
import DEFINES from '@/defines';
import router from '../../router';
import {getField, updateField} from 'vuex-map-fields';
import i18n from '@/i18n';
//initial state
function initialState () {
  return {
    key: null,
    secret: null,
    session_mode: null,
    screener: {
      id: null,
    },
    customer: null,
    access_link: null,
    oauth_host: null
  };
}
const state = initialState ();

// actions

const actions = {
  async register (context, payload) {
    var response = await API.auth.register (payload);
    return response;
  },

  async login (context, payload) {
    var response = await API.auth.login (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set consumer profile
    context.commit (
      'consumer/set_profile',
      {
        consumer: response.consumer,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer screenings
    context.commit (
      'consumer/set_screenings',
      {
        screenings: response.screenings,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer group purchases
    context.commit (
      'consumer/set_group_ticket_purchases',
      response,
      DEFINES.USE_ROOT
    );
    context.commit ('reset_oauth_host');
    return response;
  },

  async logout (context, payload) {
    if(context.state.access_link){
      context.commit ('app/resetPlayerConifg', null, DEFINES.USE_ROOT);
    }

    let oauth_host = context.state.oauth_host;
    //reset auth
    context.commit ('reset');
    context.commit ('consumer/reset', null, DEFINES.USE_ROOT);
    context.commit ('player/reset', null, DEFINES.USE_ROOT);
    context.commit ('subscription/reset', null, DEFINES.USE_ROOT);

    if(oauth_host){
      let wp_logout_url =oauth_host+'wp-login.php?action=logout'
      window.location.replace(wp_logout_url);
    } else {
      //Navigate to company home page
      router.push ({
        name: 'company.dashboard'
      });
    }

  },

  async setVerifiedCustomer (context, payload) {
    var response = await API.auth.getCustomer (payload);
    context.commit ('set_customer', {
      customer: response.customer,
    });
    return response;
  },

  async checkEmail (context, payload) {
    var response = await API.auth.checkEmail (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    return response;
  },

  async isRegistered (context, payload) {
    var response = await API.auth.isRegistered (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    return response;
  },

  async verifyOTP (context, payload) {
    var response = await API.auth.verifyOTP (payload);
    // In case of logging with link in OTP mail, there might be no key on different device/browser
    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set consumer profile
    context.commit (
      'consumer/set_profile',
      {
        consumer: response.consumer,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer screenings
    context.commit (
      'consumer/set_screenings',
      {
        screenings: response.screenings,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer group purchases
    context.commit (
      'consumer/set_group_ticket_purchases',
      response,
      DEFINES.USE_ROOT
    );
    return response;
  },

  async resendVerification (context, payload) {
    var response = await API.auth.resendVerification (payload);
    return response;
  },

  async loginSuccess (context, payload) {
    if (router.currentRoute.query.redirect) {
      return router.push (router.currentRoute.query.redirect);
    } else {
      router.push ({
        name: 'user.dashboard'
      });
    }
    console.log('login pay',payload);
    context.dispatch (
      'app/showAlert',
      {
        message: i18n.t('welcome.mew',{
          company_title: payload.company_title ?payload.company_title : 'Movies Everywhere'
        }),
        color: 'success',
      },
      DEFINES.USE_ROOT
    );
  },

  async loginWithAccessLink (context, payload) {
    var response = await API.auth.loginWithAccessLink (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set consumer profile
    context.commit (
      'consumer/set_profile',
      {
        consumer: response.consumer,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer screenings
    context.commit (
      'consumer/set_screenings',
      {
        screenings: response.screenings,
      },
      DEFINES.USE_ROOT
    );

    context.commit ('set_access_link', {
      access_link: response.access_link,
    });
    // Set Oauth hot to null so it will not affect the logouts
    // Which does not belong to oauth login
    context.commit ('reset_oauth_host');
    return response;
  },
  async loginWithAutoRegisterLink (context, payload) {
    var response = await API.auth.loginWithAutoRegisterLink (payload);
    // return response 
    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set consumer profile
    context.commit (
      'consumer/set_profile',
      {
        consumer: response.consumer,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer screenings
    context.commit (
      'consumer/set_screenings',
      {
        screenings: response.screenings,
      },
      DEFINES.USE_ROOT
    );

    context.commit ('set_access_link', {
      access_link: response.access_link,
    });
    // Set Oauth hot to null so it will not affect the logouts
    // Which does not belong to oauth login
    context.commit ('reset_oauth_host');
    return response;
  },
  async loginWithFirebase (context, payload) {
    var response = await API.auth.loginWithFirebase (payload);
    context.commit ('set_key', {
      key: response.key,
    });
    context.commit ('set_secret', {
      secret: response.secret,
    });
    context.commit ('set_session_mode', {
      session_mode: response.session_mode,
    });
    // set consumer profile
    context.commit (
      'consumer/set_profile',
      {
        consumer: response.consumer,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer screenings
    context.commit (
      'consumer/set_screenings',
      {
        screenings: response.screenings,
      },
      DEFINES.USE_ROOT
    );
    // Set consumer group purchases
    context.commit (
      'consumer/set_group_ticket_purchases',
      response,
      DEFINES.USE_ROOT
    );
    // Set Oauth hot to null so it will not affect the logouts
    // Which does not belong to oauth login
    context.commit ('reset_oauth_host');
    return response;
  },

  async mewOAuthLogin (context, payload) {
    var response = await API.auth.mewOAuthLogin (payload);
    // Set Oauth host
    context.commit ('set_oauth_host', {
      oauth_host: payload.oauth_host,
    });
    return response;
  },


};

// getters
const getters = {
  getField,
  getCustomer: state => {
    return state.customer;
  },
  getSession (state) {
    var data = {};
    data.key = state.key;
    data.secret = state.secret;
    data.session_mode = state.session_mode;
    return data;
  },
  isPreviewMode: state => {
    return state.access_link ? state.access_link.type == 20 : false;
  },
  isLoggedInWithLink: state => {
    return state.access_link ? state.access_link.type == 10 : false;
  },
  getOauthHost: state => {
    return state.oauth_host;
  }
};

// mutations
const mutations = {
  set_key (state, payload) {
    state.key = payload.key;
  },

  set_secret (state, payload) {
    state.secret = payload.secret;
  },

  set_session_mode (state, payload) {
    state.session_mode = payload.session_mode;
  },

  set_screener (state, payload) {
    state.screener = payload.screener;
  },

  set_customer (state, payload) {
    state.customer = payload.customer;
  },

  set_access_link (state, payload) {
    state.access_link = payload.access_link;
  },

  set_oauth_host (state, payload) {
    state.oauth_host = payload.oauth_host;
  },
  reset_oauth_host (state, payload) {
    state.oauth_host = null;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
